import { LinkButton } from '@dot/design-system';
import { useRef } from 'react';

import * as SC from './ManualUploadStyles';

type Props = {
  id?: string;
  onComplete: (content: Uint8Array) => void;
};

export const ManualMessageUpload = ({ id, onComplete }: Props) => {
  const inputFileRef = useRef<HTMLInputElement>(null);

  function clearInput() {
    if (inputFileRef.current) {
      inputFileRef.current.value = '';
    }
  }

  function onManualMessageUploadFileChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (!e.target.files || e.target.files.length !== 1) {
      return;
    }

    const [file] = e.target.files;
    const reader = new FileReader();

    reader.onload = async (e) => {
      const fileContent = e.target?.result;

      if (!(fileContent instanceof ArrayBuffer)) {
        return;
      }

      try {
        onComplete(new Uint8Array(fileContent));
        clearInput();
      } catch (error) {
        // eslint-disable-next-line no-alert
        alert('Wrong input file format');
      }
    };

    if (!file) {
      return;
    }

    reader.readAsArrayBuffer(file);
  }

  const onManualMessageUploadBtnClick = () => {
    if (!inputFileRef.current) {
      return;
    }

    inputFileRef.current.click();
  };

  return (
    <SC.Container>
      <SC.HiddenFileInput ref={inputFileRef} name="message" onChange={onManualMessageUploadFileChange} type="file" />
      <LinkButton id={id} onClick={onManualMessageUploadBtnClick}>
        Upload message
      </LinkButton>
    </SC.Container>
  );
};
